const speakingPress = [
  {
    headline: 'Guest Presenter',
    meta: 'University of Toledo · 2026',
    description:
      'Returned to her alma mater to speak with students in the College of Engineering on founding a startup, building in public, and navigating the jump from enterprise software to early-stage entrepreneurship.',
    linkLabel: 'View Presentation →',
    url: 'https://voxxy-drive.replit.app/s/courtneygreer/from-idea-to-impact-a-founders-guide-to-entrepreneurship-ai',
  },
  {
    headline: 'Panelist',
    meta: 'AI & Sustainability Global Summit · NYC · July 2025',
    description:
      'Hosted by GEMI.AI and Columbia University Technology Management. Courtney joined the Responsible AI and Community Impact panel, speaking on how AI can be built in service of inclusive, sustainable, and human-centered experiences.',
    linkLabel: 'Read the Recap →',
    url:
      'https://www.linkedin.com/posts/courtney-greer_i-had-a-fantastic-time-speaking-at-gemiai-activity-7353094889775005696-F7hh?utm_source=share&utm_medium=member_desktop&rcm=ACoAAA56CmABt_QI-ZXgbQvQPaqejKiFdbGhk9E',
  },
  {
    headline: 'Guest Speaker',
    meta: 'Association for Computing Machinery, University of Toledo',
    description:
      "Delivered a talk on growth mindset to student engineers at her alma mater, drawing on Dr. Carol Dweck's research and her own path from CS undergrad to enterprise technologist to founder. Hosted by ACM President Taylor Buckey.",
    linkLabel: 'View Post →',
    url:
      'https://www.linkedin.com/posts/courtney-greer_growthmindset-softskills-mindsetdevelopment-activity-7188657901656317952-XDqo?utm_source=share&utm_medium=member_desktop&rcm=ACoAAA56CmABt_QI-ZXgbQvQPaqejKiFdbGhk9E',
  },
  {
    headline: 'Navigating the GenAI FOMO',
    meta: 'LinkedIn Pulse · Mar 2024',
    description:
      'On the digital divide in the GenAI era, democratizing technology, community-led development, and why inclusive adoption matters when disruptive tech creates real fear of missing out.',
    linkLabel: 'Read article →',
    url: 'https://www.linkedin.com/pulse/navigating-genai-fomo-ensuring-inclusivity-era-disruptive-greer-milke/',
  },
];

export default speakingPress;
